"use client";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { ColumnDef } from "@tanstack/react-table";

import { Badge } from "@/components/ui/badge";
import { DataNilaiRaportSmbjm } from "@/types";
import { ArrowUpDown } from "lucide-react";

export const columns: ColumnDef<DataNilaiRaportSmbjm>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && "indeterminate")
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "id_data_pendaftaran",
    header: "",
  },
  {
    accessorKey: "jml_belum_cek",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Jumlah Belum dicek
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
    cell: ({ row }) => {
      if (Number(row.original.jml_belum_cek) > 0)
        return (
          <div>
            <Badge variant={"secondary"}>
              {row.original.jml_belum_cek} Nilai
            </Badge>
          </div>
        );

      return (
        <div>
          <Badge variant={"success"}>Sudah diverifikasi</Badge>
        </div>
      );
    },
  },
  {
    id: "status_rekon",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Status Rekon
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const jmlBelumCek = Number(row.original.jml_belum_cek) || 0;
      const jmlNilaiRekon = Number((row.original as any).jml_nilai_rekon) || 0;
      const isSudahRekon = 5 - jmlBelumCek >= jmlNilaiRekon;

      if (
        Number((row.original as any).jml_nilai_rekon) == 0 ||
        !row.original?.jml_nilai_rekon
      ) {
        return null;
      }

      if (isSudahRekon) {
        return (
          <div>
            <Badge variant={"success"}>Sudah Rekon</Badge>
          </div>
        );
      }

      return (
        <div>
          <Badge variant={"secondary"}>Belum Rekon</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "nomor_pendaftaran",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nomor Pendaftaran
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  {
    accessorKey: "nama_lengkap",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nama Lengkap
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  {
    accessorKey: "email",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Email
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  {
    accessorKey: "handphone",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          No Handphone
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  {
    accessorKey: "nisn",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          NISN
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  {
    accessorKey: "npsn_sekolah",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          NPSN Sekolah
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },
  {
    accessorKey: "nama_sekolah",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nama Sekolah
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
  },

  // {
  //   id: "actions",
  //   cell: ({ row }) => {
  //     return <Actions row={row.original} />;
  //   },
  // },
];
